import {useRef, useCallback} from 'react';

export default function useDebounce(fn, delay, deps) {
    const timeout = useRef();

    const debouncedFunction = useCallback((...args) => {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }

        timeout.current = setTimeout(() => {
            fn(...args);
        }, delay);
    }, deps || []);

    return debouncedFunction;
}



// WEBPACK FOOTER //
// ./src/components/helpers/hooks/useDebounce.js